/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetMetricDataSourcesPathParams = NonNullable<operations['getMetricDataSources']['parameters']['path']>;

export type GetMetricDataSourcesQueryParams = NonNullable<operations['getMetricDataSources']['parameters']['query']>;

export interface Input extends GetMetricDataSourcesPathParams {
  apiVersion?: string;
  query?: GetMetricDataSourcesQueryParams;
}

export async function getMetricDataSources(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/metric-data-sources', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
